/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Body of `PUT /superadmin/users/{user_id}/organizations/{organization_id}/active`.
 * @export
 * @interface MembershipActiveUpdate
 */
export interface MembershipActiveUpdate {
    /**
     * The membership's new status in the organization
     * @type {boolean}
     * @memberof MembershipActiveUpdate
     */
    is_active: boolean;
}

/**
 * Check if a given object implements the MembershipActiveUpdate interface.
 */
export function instanceOfMembershipActiveUpdate(value: object): value is MembershipActiveUpdate {
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    return true;
}

export function MembershipActiveUpdateFromJSON(json: any): MembershipActiveUpdate {
    return MembershipActiveUpdateFromJSONTyped(json, false);
}

export function MembershipActiveUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MembershipActiveUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'is_active': json['is_active'],
    };
}

export function MembershipActiveUpdateToJSON(json: any): MembershipActiveUpdate {
    return MembershipActiveUpdateToJSONTyped(json, false);
}

export function MembershipActiveUpdateToJSONTyped(value?: MembershipActiveUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_active': value['is_active'],
    };
}

